module.exports = __webpack_public_path__ + "img/ru.37249440.png";